import React, { memo } from "react";

import { BottomSpacer } from "components/ProjectTree/components/NodeLayout";
import { WizardTopologyMenuFolder } from "./WizardTopologyMenuFolder";

export const WizardTopologyMenuNodeLayout = memo(
  ({ level, data, options, hasChildren, isOpen, ...props }) => (
    <div className="w-100 h-100 py-2_5 position-relative">
      <WizardTopologyMenuFolder
        presentation={data?.presentation}
        handleToggle={data?.handleToggleDetails}
        hasChildren={hasChildren}
        id={data?.id}
        isIconsShown={false}
        isOpen={isOpen}
        kind={data?.kind}
        title={data?.title}
        dummy={data?.dummy}
        type={data?.type}
        menu={data?.menu}
        orderCode={data?.orderCode}
        selectedAccessories={data?.selectedAccessories}
        translations={data?.translations}
        level={level}
        groupPosition={data?.groupPosition}
        {...props}
      />

      <BottomSpacer
        options={options}
        hasChildren={hasChildren}
        isOpen={isOpen}
      />
    </div>
  ),
);
